import { useSelector } from "react-redux"
import { GoalSection, LeftColumnWrapper, GoalHeadingGrey, GoalHeadingBlock, GoalBodyText, RightColumnWrapper, GoalImage, UnorderedList, Bullets } from "./OurGoalStyle"
import our_goal from "./01_images/our_goal.jpg"
import { about } from "../../../i18n/03_about"
import ImageWithLoader from "../../../components/04_common/04_inlineLoader/ImageWithLoader";

const OurGoal = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = about[lang]

    return (
        <GoalSection>
            <LeftColumnWrapper>
                <GoalHeadingGrey>
                    {t.goalHeadingGrey}
                </GoalHeadingGrey>
                <GoalHeadingBlock>
                    {t.goalHeadingBlock}
                </GoalHeadingBlock>
                        <GoalBodyText>
                            {t.goalBodyText}<br />
                            {t.goalUnorderedList.map((value, index) => (
                                <UnorderedList key={index}>
                                    <Bullets>
                                        {value}
                                    </Bullets>
                                </UnorderedList>
                            ))}
                        </GoalBodyText>
            </LeftColumnWrapper>
            <RightColumnWrapper>
                <ImageWithLoader src={our_goal} loaderLabel="Loading…" />
            </RightColumnWrapper>
        </GoalSection>
    )
}

export default OurGoal